(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
(function ($, _Swiper) {
  var burger = document.querySelector('.burger');
  var menu = document.querySelector('.menu');
  var header = document.querySelector('.l-header');
  burger.addEventListener('click', function () {
    burger.classList.toggle('open');
    menu.classList.toggle('open');
    header.classList.toggle('open');
    header.classList.remove('scroll-top');
  });
  $('a[href^="#"]').click(function () {
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    var speed = 500;
    $("html, body").animate({
      scrollTop: position
    }, speed, "swing");
    return false;
  });
  var setViewport = function setViewport(setWidth) {
    var standardWidth = setWidth || 375; // 基準サイズ
    // 以下略
  };

  document.addEventListener("DOMContentLoaded", function () {
    setViewport(360); // 引数を入力すると適用/未入力だと上記で指定したサイズ(375px)
  });

  //const pagetop_btn = document.querySelector(".pagetop");
  // .pagetopをクリックしたら
  //pagetop_btn.addEventListener("click", scroll_top);
  // ページ上部へスムーズに移動
  //function scroll_top() {
  //window.scroll({ top: 0, behavior: "smooth" });
  //}

  window.addEventListener('scroll', function () {
    var element = document.getElementById('globalHeader'); // 対象の要素のIDを指定

    // 要素の位置とウィンドウのスクロール量を比較してクラスを付与するかどうか判断
    if (window.scrollY > element.offsetTop) {
      element.classList.remove('scroll-top'); // クラスを削除
    } else {
      element.classList.add('scroll-top'); // クラスを追加
    }
  });

  var swiper = new Swiper(".swiper", (_Swiper = {
    slidesPerView: 2,
    spaceBetween: 12,
    allowTouchMove: false,
    freeMode: true,
    loop: true,
    autoplay: true,
    //自動でスライドさせる
    speed: 8000
  }, _defineProperty(_Swiper, "autoplay", {
    delay: 0,
    pauseOnMouseEnter: false,
    // 追記
    disableOnInteraction: false // 追記
  }), _defineProperty(_Swiper, "breakpoints", {
    // スライドの表示枚数：500px以上の場合
    768: {
      slidesPerView: 3,
      spaceBetween: 20
    }
  }), _Swiper));
  window.addEventListener('scroll', function () {
    var element = document.getElementById('globalHeader'); // 対象の要素のIDを指定

    // 要素の位置とウィンドウのスクロール量を比較してクラスを付与するかどうか判断
    if (window.scrollY > element.offsetTop) {
      element.classList.remove('scroll-top'); // クラスを削除
    } else {
      element.classList.add('scroll-top'); // クラスを追加
    }
  });
})(jQuery);

},{}]},{},[1]);
